var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlusV2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "262.445 97.832 38 38",
    width: 38,
    height: 38,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M 300.445 117.832 L 300.445 114.832 C 300.445 113.352 300.015 112.832 298.445 112.832 L 285.445 112.832 L 285.445 99.832 C 285.445 98.352 284.955 97.832 283.445 97.832 L 280.445 97.832 C 278.895 97.832 278.445 98.352 278.445 99.832 L 278.445 112.832 L 264.445 112.832 C 262.965 112.832 262.445 113.322 262.445 114.832 L 262.445 117.832 C 262.445 119.382 262.965 119.832 264.445 119.832 L 278.445 119.832 L 278.445 133.832 C 278.445 135.342 278.925 135.832 280.445 135.832 L 283.445 135.832 C 284.925 135.832 285.445 135.402 285.445 133.832 L 285.445 119.832 L 298.445 119.832 C 299.955 119.832 300.445 119.352 300.445 117.832 Z",
    transform: "matrix(0.9999999999999999, 0, 0, 0.9999999999999999, 0, 0)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusV2);
export default __webpack_public_path__ + "static/media/plus-v2.41254a38.svg";
export { ForwardRef as ReactComponent };